import { Outlet } from "react-router-dom";
import { useFlowCorrelationId } from "@/hooks/useFlowCorrelationId";

export const MFEWrapper = () => {
  useFlowCorrelationId();

  return (
    <div className="cashier-mfe-wrapper">
      <Outlet />
    </div>
  );
};
